module.exports = __webpack_public_path__ + "img/wind_speed.0ffbdaaf.png";